/**
 * Energy sensor config - watt, watt_hour, voltage for EnergyChart
 * Reuses chartableSensorConfig, filters to energy-related sensors
 */
import {
  getChartableSensors,
  CHARTABLE_SENSOR_CONFIG,
  type ChartableSensorOption,
} from './chartableSensorConfig'

export type EnergySensorId = 'watt' | 'watt_hour' | 'voltage'

const ENERGY_SENSOR_IDS: EnergySensorId[] = ['watt', 'watt_hour', 'voltage']

/** Mock energy sensor options when no deviceSN */
export const MOCK_ENERGY_SENSOR_OPTIONS: ChartableSensorOption[] = ENERGY_SENSOR_IDS.map(
  (id) => CHARTABLE_SENSOR_CONFIG[id]
)

/** Get energy sensor options. When deviceSN provided, fetch and filter; otherwise use mock */
export async function getEnergySensors(
  deviceSN?: string | null,
  credentials?: { apiKey?: string; appId?: string }
): Promise<ChartableSensorOption[]> {
  const all = await getChartableSensors(deviceSN, credentials)
  const energySet = new Set(ENERGY_SENSOR_IDS)
  const filtered = all.filter((s) => energySet.has(s.id as EnergySensorId))
  return filtered.length > 0 ? filtered : MOCK_ENERGY_SENSOR_OPTIONS
}
